export default __webpack_public_path__ + "static/media/facebook_messenger.737fa2d7.svg";